import { Form, Formik } from "formik";
import Input from "../shared/Input/Input";
import Button from "@mui/material/Button";
import "./Register.scss";
import { useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import * as Yup from "yup";
import { regex } from "../../constants/regex";
import { errorMessages } from "../../constants/errorMessages";
import { useLazySetPasswordQuery } from "../../services/rtkQueryServices/authenticationService";
import { LOGIN_LITERALS } from "../../constants/literals";

const SetPassword = (props: any) => {
  const { formRef } = props;
  const [errorMessage, setErrorMessage] = useState<string>("");
  const navigate = useNavigate();
  const initialFormValue = useMemo<any>(() => {
    return {
      password: "",
      confirmPassword: "",
    };
  }, []);
  const [SetPassword] = useLazySetPasswordQuery();
  const validationSchema = () =>
    Yup.object({
      password: Yup.string()
        .required(errorMessages.required("Password"))
        .min(8, errorMessages.minCharacterLimit("Password", 8))
        .max(64, errorMessages.characterLimit("Password", 64))
        .matches(regex.passwordValidation, errorMessages.passwordRegexMatch),
      confirmPassword: Yup.string()
        .required(errorMessages.required("Password"))
        .oneOf([Yup.ref("password")], errorMessages.confirmPassword),
    });
  return (
    <>
      <div className="login-header d-flex flex-column align-items-center w-100 pt-5 pb-3">
        Set password for your account
      </div>
      <Formik
        innerRef={formRef}
        initialValues={initialFormValue}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          SetPassword(values).then((res) => {
            if (res.isSuccess) {
              navigate("/login");
            } else if (res.isError) {
              setErrorMessage(
                (res.error as any)?.data?.message ||
                  LOGIN_LITERALS.somethingWentWrong
              );
            }
          });
        }}
      >
        {(formik) => (
          <Form
            //   onKeyDown={Utility.preventSubmitOnEnter}
            onSubmit={formik.handleSubmit}
            className="login-form-container login-details"
          >
            <div className="login-form d-flex flex-column">
              <Input
                name="password"
                label="Password"
                placeholder="Enter Password"
                type="password"
                errorMsg={
                  (formik.touched.password || formik.submitCount > 0) &&
                  formik.errors.password &&
                  (formik.errors as any).password
                }
                value={formik.values.password}
                onInput={(e) => {
                  formik.handleChange(e);
                  setErrorMessage("");
                }}
                required
              />
              <Input
                name="confirmPassword"
                label="Confirm Password"
                placeholder="Confirm your Password"
                type="password"
                errorMsg={
                  (formik.touched.confirmPassword || formik.submitCount > 0) &&
                  formik.errors.confirmPassword &&
                  (formik.errors as any).confirmPassword
                }
                value={formik.values.confirmPassword}
                onInput={(e) => {
                  formik.handleChange(e);
                  setErrorMessage("");
                }}
                required
              />
            </div>
            <div className="d-flex justify-content-between flex-column gap-3 line-top py-3 registration-form-button">
              {/* <Button
                className="flex-grow-1"
                style={{ color: "#696969" }}
                variant="text"
                type="button"
                onClick={() => {
                  props.prevStep();
                }}
              >
                Back
              </Button> */}

              <Button variant="contained" type="submit">
                Submit
              </Button>
              <div className="error-message">{errorMessage}</div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default SetPassword;
